import MaterialReactTable from "material-react-table"
import React, { useCallback, useMemo } from "react"
//Import Material React Table Translations
import { darken } from "@mui/material"
import { MRT_Localization_ES } from "material-react-table/locales/es"

const TablaLiquidaciones = ({ columnas, lineas, handleOpen }) => {
  const columns = useMemo(() => columnas, [])
  const [data, setData] = React.useState(lineas)
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 5,
  })
  const [abrir, setAbrir] = React.useState(false)

  React.useEffect(() => {
    if (lineas.length > 0) {
      setData(lineas)
    }
  }, [lineas])

  //abrir modal
  const handleOpenModalTable = () => {
    setAbrir(true)
  }
  //cerrar modal
  const handleCloseModalTable = () => {
    setAbrir(false)
  }
  //submit del formulario del modal
  const handleSubmit = (values) => {
    console.log(values)
    data.push(values)
    setData([...data])
    // onClose();
  }

  // const handleCreateNewRow = (values) => {
  //     data.push(values);
  //     setData([...data]);
  // };

  const handleDeleteRow = useCallback(
    (row) => {
      if (!window.confirm(`Estas seguro que deseas eliminar este registro?`)) {
        return
      }
      // funcionEliminar(tableData[row.index])
      data.splice(row.index, 1)
      setData([...data])
      // .then(() => {
      //     //cuando se cumpla la funcion de eliminar, se va a eliminar de la tabla
      //     tableData.splice(row.index, 1);
      //     setTableData([...tableData]);
      // })
    },
    [data]
  )

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    data[row.index] = values
    //send/receive api updates here, then refetch or update local table data for re-render
    setData([...data])
    exitEditingMode() //required to exit editing mode and close modal
  }

  return (
    <>
      <MaterialReactTable
        muiTablePaginationProps={{
          rowsPerPageOptions: [5, 10],
        }}
        // onPaginationChange={setPagination} //hoist pagination state to your state when it changes internally
        columns={columns}
        data={data}
        muiTablePaperProps={{
          elevation: 0,
          sx: (theme) => ({
            borderRadius: "0",
            border: darken(theme.palette.background.default, 0.1),
            bgcolor: theme.palette.mode == "dark" ? "#24292e" : "#bdbdbd",
          }),
        }}
        muiTableBodyProps={{
          sx: (theme) => ({
            "& tr:nth-of-type(odd)": {
              backgroundColor: theme.palette.mode == "dark" ? "#24292e" : "#bdbdbd",
            },
          }),
        }}
        onPaginationChange={setPagination}
        state={{ pagination }}
        enableColumnFilterModes={true}
        enableColumnOrdering={true}
        enableColumnFilters={true}
        enableSorting={true}
        enableColumnResizing
        columnResizeMode="onChange"
        enablePinning
        enableRowActions={false}
        enableStickyHeader
        initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: "compact" }}
        positionToolbarAlertBanner="bottom"
        localization={MRT_Localization_ES}
        defaultColumn={{
          maxSize: 400,
          minSize: 40,
        }}
        // renderTopToolbarCustomActions={() => (
        //     <>
        //         <Tooltip arrow placement="right" title="Nueva Gestión">
        //             <Button
        //                 variant="contained"
        //                 onClick={() => handleOpenModalTable()}
        //             >
        //                 <PlaylistAddIcon />
        //             </Button>
        //         </Tooltip>
        //     </>
        // )}
      />
    </>
  )
}

export default TablaLiquidaciones
